import React from 'react'

export default function CompetitionRestrictionSummary({ restrictions: r, omitGender = false }) {
  const restrictions = []
  if (r?.minAge || r?.maxAge) restrictions.push('Age: ' + (r.minAge && r.maxAge ? r.minAge + '–' + r.maxAge : r.minAge ? r.minAge + '+' : 'up to ' + r.maxAge))
  if (r?.rank > 0) restrictions.push('Max rank: ' + r.rank)
  if (r?.gender && !omitGender) restrictions.push(({ male: 'Men', female: 'Women', mixt: 'Mixed' })[r.gender] || r.gender)
  if (r?.teamAverageLevel) restrictions.push('Team average level')
  if (r?.forbiddenToTeams) restrictions.push('Forbidden to teams')
  if (r?.accountType === 'summerAndPremium') restrictions.push('Premium')
  if (r?.accountActivity && r.accountActivity !== 'any') {
    const [minimum, recent] = r.accountActivity.split('-')
    restrictions.push('Min. activity: ' + minimum + (recent ? ' (last 52 weeks)' : ' (all time)'))
  }
  return <>{restrictions.length ? restrictions.join(' · ') : omitGender && r?.gender ? null : r ? 'No restrictions' : 'Restrictions unavailable'}</>
}
